import { combineReducers } from "redux";

// Reducers
import currentPageReducer from "./slices/currentPage";
import appSettingsReducer from "./slices/appSettings";
import singleProductReducer from "./slices/singleProduct";
import cartReducer from "./slices/cart";
import loaderReducer from "./slices/loader";
import queryCacheReducer from "./slices/queryCache";
import productQuery from "./slices/productQuery";
import menuReducer from "./slices/menu";
import searchReducer from "./slices/search";

export default combineReducers({
    appSettings: appSettingsReducer,
    currentPage: currentPageReducer,
    menu: menuReducer,
    search: searchReducer,
    cart: cartReducer,
    singleProduct: singleProductReducer,
    loader: loaderReducer,
    queryCache: queryCacheReducer,
    productQuery: productQuery
});